module.exports = __webpack_public_path__ + "static/dmm-de60f3298199e23511547378860393ec.jpg";